import { StatusTagProps } from "@portal/BaseComponents/Table/Components/StatusTag/StatusTag";
import { AssociatedInvoice, Invoice } from "./invoice";
import { SourceApp } from "./source-app";
import { UserUI_DV_DTO } from "./user";

export type PTPView = "ALL" | "OPEN" | "CLOSED";
export type PTPStatus = Exclude<PTPView, "ALL">;
export const PTPfieldIds = {
  pay_date: "pay_date",
  description: "description",
  amount_details: "amount_details",
  invoice_ids: "invoice_ids",
  status: "status",
  against_invoices: "against_invoices",
  amount: "amount",
} as const;

const ptp_sort_col = [
  "DEFAULT",
  "ID",
  "PTP_DATE",
  "PTP_BALANCE",
  "INVOICE_BALANCE",
  "CLOSED_DATE",
] as const;

export type PTPSortCol = (typeof ptp_sort_col)[number];
export interface PTPList {
  id: string;
  description: string;
  currency: string;
  amount: number;
  amount_base_currency: number;
  balance_amount: number;
  balance_amount_base_currency: number;
  invoice?: Invoice;
  pay_date: string;
  title: string;
  status: PTPStatus;
  created_at: string;
  updated_at: string;
  source_app: SourceApp;
}
export interface PTPOwners extends UserUI_DV_DTO {}
export interface PTPCreatedBy extends UserUI_DV_DTO {}
export interface PTPClosedBy extends UserUI_DV_DTO {}

export type PTPStatusConfig = {
  [key in PTPStatus]: {
    label: string;
    style: StatusTagProps["style"];
  };
};

export interface PTPAmountDetails {
  invoice_id: string;
  amount: number;
}

export interface CreatePTP {
  [PTPfieldIds.pay_date]: string;
  [PTPfieldIds.description]: string;
  [PTPfieldIds.amount_details]: PTPAmountDetails[];
  [PTPfieldIds.status]?: PTPStatus;
}

export interface CreateCustomerLevelPTP {
  [PTPfieldIds.pay_date]: string;
  [PTPfieldIds.description]?: string;
  [PTPfieldIds.amount]: number;
}

export interface CustomerLevelPTPAmountCheck {
  [PTPfieldIds.pay_date]?: string;
  [PTPfieldIds.amount]?: number;
}

export interface CustomerLevelPTPAmountCheckResult {
  valid: boolean;
  message?: string;
  outstanding_amount: number;
  open_ptp_amount: number;
  available_amount: number;
  currency: string;
}
export interface PTPDetails {
  id: string;
  currency: string;
  amount: number;
  amount_base_currency: number;
  balance_amount: number;
  balance_amount_base_currency: number;
  description: string;
  invoice?: AssociatedInvoice;
  pay_date: string;
  title: string;
  status: PTPStatus;
  exchange_rate?: string;
  created_by?: PTPCreatedBy;
  closed_by?: PTPClosedBy;
  created_at: string;
  updated_by: PTPCreatedBy;
  source_app: SourceApp;
  updated_at: string;
}
